import Step2 from './Step2'
import ConnectedStep2 from './ConnectedStep2'

export { Step2 }
export default ConnectedStep2
